// Keyboard di layar (HP/tablet): saat kotak isian dipilih, geser halaman
// supaya kotak itu tetap terlihat di atas keyboard. Meta viewport memakai
// interactive-widget=resizes-content (Chrome Android) sehingga tata letak ikut
// mengecil; di browser lain visualViewport dipakai untuk mendeteksi keyboard.
import { layarSentuh } from '../core/dom.js';

const isian = el => el && (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !/^(button|checkbox|radio|submit|range)$/.test(el.type)));

function tampakkan() {
  const el = document.activeElement;
  if (!isian(el)) return;
  const vv = window.visualViewport;
  const r = el.getBoundingClientRect();
  const atas = vv ? vv.offsetTop : 0, bawah = vv ? vv.offsetTop + vv.height : innerHeight;
  // Sudah terlihat dengan sedikit ruang di bawahnya: biarkan.
  if (r.top >= atas + 8 && r.bottom <= bawah - 24) return;
  el.scrollIntoView({ block: 'center', inline: 'nearest' });
}

export function initKeyboard() {
  if (!layarSentuh()) return;
  let t = 0;
  const nanti = ms => { clearTimeout(t); t = setTimeout(tampakkan, ms); };
  // Keyboard butuh waktu untuk muncul; periksa setelah animasinya selesai.
  // Selama mengetik, bilah tombol bawah disembunyikan (lihat hp.css) supaya
  // ruang di atas keyboard tidak habis.
  document.addEventListener('focusin', e => { if (isian(e.target)) { document.documentElement.classList.add('sedang-isi'); nanti(350); setTimeout(tampakkan, 700); } });
  document.addEventListener('focusout', () => setTimeout(() => { if (!isian(document.activeElement)) document.documentElement.classList.remove('sedang-isi'); }, 0));
  window.visualViewport?.addEventListener('resize', () => nanti(60));
  window.addEventListener('resize', () => nanti(60));
}
